import { render, staticRenderFns } from "./DPHL.vue?vue&type=template&id=1d697328&scoped=true"
import script from "./DPHL.vue?vue&type=script&lang=js"
export * from "./DPHL.vue?vue&type=script&lang=js"
import style0 from "./DPHL.vue?vue&type=style&index=0&id=1d697328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d697328",
  null
  
)

export default component.exports